import {
  EobControllerApi,
  UploadEobDocumentFormatEnum,
} from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface UploadEobParams {
  payerId: string;
  eobNumber: string;
  paymentMethod: string;
  totalPaymentAmount: string;
  statementDate: string;
  // File is optional — an EOB can be created without attaching a document.
  documentFormat?: UploadEobDocumentFormatEnum;
  file?: File;
  checkEftNumber?: string;
  documentName?: string;
}

export const useUploadEob = () =>
  useMutationWithLoading(async (params: UploadEobParams) =>
    new EobControllerApi(getConfigObject()).uploadEob(
      params.payerId,
      params.eobNumber,
      params.totalPaymentAmount,
      params.paymentMethod,
      params.checkEftNumber,
      params.statementDate,
      params.documentFormat,
      params.documentName,
      getXtenantId(),
      params.file
    )
  );
